import { ApiProperty } from "@nestjs/swagger";
import { ReportingTypeEnum } from "@project-management-system/shared-models";
import { IsNotEmpty } from "class-validator";

export class operationReportRequest {
    @ApiProperty()
    sampleRequestId: number;
    @ApiProperty()
    operationId: number;
    @ApiProperty()
    operationCode: string;
    @ApiProperty()
    sequence: number;
    @ApiProperty()
    colorId: number;
    @ApiProperty()
    sizeId: number;
    @ApiProperty()
    quantity: number;
    @ApiProperty()
    reporterId: number;
    @ApiProperty()
    supervisorId: number;
    @ApiProperty()
    reportingTime: Date;
    @ApiProperty()
    damagedQuantity?: number;
    @ApiProperty()
    rejectedQuantity?: number;
    @ApiProperty()
    reportingType?: ReportingTypeEnum;
}